// SBIS Consulting — Custom Date Picker (gold-themed)

const DAYS = ['Po', 'Ut', 'Sr', '\u010Cet', 'Pet', 'Sub', 'Ned'];
const MONTHS = ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar'];

let activePicker = null;

function pad(n) { return n < 10 ? '0' + n : '' + n; }

function fmtDate(d) { return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear(); }

function parseInputDate(val) {
  if (!val) return null;
  let m = val.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (m) return new Date(+m[3], +m[2] - 1, +m[1]);
  m = val.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
  return null;
}

function closePicker() {
  if (activePicker) {
    activePicker.el.classList.remove('dp-open');
    setTimeout(() => { if (activePicker?.el) activePicker.el.remove(); activePicker = null; }, 200);
  }
}

function buildPicker(inputEl) {
  closePicker();

  const currentDate = parseInputDate(inputEl.value) || new Date();
  let viewYear = currentDate.getFullYear();
  let viewMonth = currentDate.getMonth();
  const selectedDate = parseInputDate(inputEl.value);

  const picker = document.createElement('div');
  picker.className = 'dp-picker';

  function render() {
    picker.textContent = '';

    // Header: arrows + month/year
    const hdr = document.createElement('div');
    hdr.className = 'dp-hdr';

    const prevYear = document.createElement('button');
    prevYear.className = 'dp-nav';
    prevYear.textContent = '\u00AB';
    prevYear.title = 'Prethodna godina';
    prevYear.onclick = e => { e.stopPropagation(); viewYear--; render(); };

    const prev = document.createElement('button');
    prev.className = 'dp-nav';
    prev.textContent = '\u2039';
    prev.title = 'Prethodni mesec';
    prev.onclick = e => { e.stopPropagation(); viewMonth--; if (viewMonth < 0) { viewMonth = 11; viewYear--; } render(); };

    const title = document.createElement('span');
    title.className = 'dp-title';
    title.textContent = MONTHS[viewMonth] + ' ' + viewYear;

    const next = document.createElement('button');
    next.className = 'dp-nav';
    next.textContent = '\u203A';
    next.title = 'Slede\u0107i mesec';
    next.onclick = e => { e.stopPropagation(); viewMonth++; if (viewMonth > 11) { viewMonth = 0; viewYear++; } render(); };

    const nextYear = document.createElement('button');
    nextYear.className = 'dp-nav';
    nextYear.textContent = '\u00BB';
    nextYear.title = 'Slede\u0107a godina';
    nextYear.onclick = e => { e.stopPropagation(); viewYear++; render(); };

    hdr.append(prevYear, prev, title, next, nextYear);
    picker.appendChild(hdr);

    // Day-of-week headers
    const dayHdr = document.createElement('div');
    dayHdr.className = 'dp-days-hdr';
    DAYS.forEach(d => {
      const span = document.createElement('span');
      span.textContent = d;
      dayHdr.appendChild(span);
    });
    picker.appendChild(dayHdr);

    // Day grid
    const grid = document.createElement('div');
    grid.className = 'dp-grid';

    const firstDay = new Date(viewYear, viewMonth, 1);
    // Monday=0, Sunday=6
    let startDow = firstDay.getDay() - 1;
    if (startDow < 0) startDow = 6;

    const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
    const daysInPrev = new Date(viewYear, viewMonth, 0).getDate();

    const today = new Date();
    const todayStr = today.getFullYear() + '-' + pad(today.getMonth() + 1) + '-' + pad(today.getDate());
    const selStr = selectedDate ? selectedDate.getFullYear() + '-' + pad(selectedDate.getMonth() + 1) + '-' + pad(selectedDate.getDate()) : '';

    // Previous month filler days
    for (let i = startDow - 1; i >= 0; i--) {
      const btn = document.createElement('button');
      btn.className = 'dp-day dp-other';
      btn.textContent = daysInPrev - i;
      const d = new Date(viewYear, viewMonth - 1, daysInPrev - i);
      btn.onclick = e => { e.stopPropagation(); selectDate(d, inputEl); };
      grid.appendChild(btn);
    }

    // Current month days
    for (let i = 1; i <= daysInMonth; i++) {
      const btn = document.createElement('button');
      btn.className = 'dp-day';
      btn.textContent = i;
      const dateStr = viewYear + '-' + pad(viewMonth + 1) + '-' + pad(i);
      if (dateStr === todayStr) btn.classList.add('dp-today');
      if (dateStr === selStr) btn.classList.add('dp-selected');
      const d = new Date(viewYear, viewMonth, i);
      btn.onclick = e => { e.stopPropagation(); selectDate(d, inputEl); };
      grid.appendChild(btn);
    }

    // Next month filler days
    const totalCells = startDow + daysInMonth;
    const remainder = totalCells % 7;
    if (remainder > 0) {
      for (let i = 1; i <= 7 - remainder; i++) {
        const btn = document.createElement('button');
        btn.className = 'dp-day dp-other';
        btn.textContent = i;
        const d = new Date(viewYear, viewMonth + 1, i);
        btn.onclick = e => { e.stopPropagation(); selectDate(d, inputEl); };
        grid.appendChild(btn);
      }
    }

    picker.appendChild(grid);

    // Footer: Danas / Obri\u0161i
    const footer = document.createElement('div');
    footer.className = 'dp-footer';

    const btnToday = document.createElement('button');
    btnToday.className = 'dp-btn dp-btn-today';
    btnToday.textContent = 'Danas';
    btnToday.onclick = e => { e.stopPropagation(); selectDate(new Date(), inputEl); };

    const btnClear = document.createElement('button');
    btnClear.className = 'dp-btn dp-btn-clear';
    btnClear.textContent = 'Obri\u0161i';
    btnClear.onclick = e => { e.stopPropagation(); inputEl.value = ''; inputEl.dispatchEvent(new Event('change')); closePicker(); };

    footer.append(btnToday, btnClear);
    picker.appendChild(footer);
  }

  render();
  return picker;
}

function selectDate(date, inputEl) {
  inputEl.value = fmtDate(date);
  inputEl.dispatchEvent(new Event('change'));
  closePicker();
}

function positionPicker(picker, inputEl) {
  const rect = inputEl.getBoundingClientRect();

  picker.style.position = 'fixed';
  picker.style.left = rect.left + 'px';
  picker.style.top = (rect.bottom + 4) + 'px';

  // After rendering, check if it overflows
  requestAnimationFrame(() => {
    const pRect = picker.getBoundingClientRect();
    if (pRect.bottom > window.innerHeight - 10) {
      picker.style.top = (rect.top - pRect.height - 4) + 'px';
    }
    if (pRect.right > window.innerWidth - 10) {
      picker.style.left = (window.innerWidth - pRect.width - 10) + 'px';
    }
    picker.classList.add('dp-open');
  });
}

/** Bind date picker to a single input element */
export function bindDatePicker(el) {
  if (!el || el.dataset.dpBound) return;
  el.dataset.dpBound = '1';
  if (el.value && el.value.match(/^\d{4}-\d{2}-\d{2}$/)) {
    const d = parseInputDate(el.value);
    if (d) el.value = fmtDate(d);
  }
  el.addEventListener('click', e => {
    e.stopPropagation();
    if (activePicker && activePicker.input === el) { closePicker(); return; }
    const picker = buildPicker(el);
    document.body.appendChild(picker);
    positionPicker(picker, el);
    activePicker = { el: picker, input: el };
  });
}

export function initDatePickers() {
  const ids = ['dtFrom', 'dtTo', 'dtFromK', 'dtToK'];
  ids.forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;

    // Convert existing YYYY-MM-DD value to dd.mm.yyyy display
    if (el.value && el.value.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const d = parseInputDate(el.value);
      if (d) el.value = fmtDate(d);
    }

    el.addEventListener('click', e => {
      e.stopPropagation();
      if (activePicker && activePicker.input === el) { closePicker(); return; }
      const picker = buildPicker(el);
      document.body.appendChild(picker);
      positionPicker(picker, el);
      activePicker = { el: picker, input: el };
    });
  });

  // Close on outside click
  document.addEventListener('click', e => {
    if (activePicker && !activePicker.el.contains(e.target) && !e.target.closest('.dp-picker')) {
      closePicker();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && activePicker) closePicker();
  });
}

/** Format a Date as dd.mm.yyyy for use in date inputs */
export function formatDateForInput(date) {
  return fmtDate(date);
}
